import { render, staticRenderFns } from "./CardRoomPlayerName.vue?vue&type=template&id=23222462&scoped=true"
import script from "./CardRoomPlayerName.vue?vue&type=script&lang=js"
export * from "./CardRoomPlayerName.vue?vue&type=script&lang=js"
import style0 from "./CardRoomPlayerName.vue?vue&type=style&index=0&id=23222462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23222462",
  null
  
)

export default component.exports